import React from 'react'
import Image from 'react-bootstrap/Image'
import "./PanelImage.css"

export const PanelImage = ({ albumTitle }) => {

  return (
    <Image className="imagebox" src={albumTitle} draggable={false} fluid/>
  )
}